import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";

// Busqueda de plantillas según el perfil
export const findFormListByProfile = createAsyncThunk(
  "profileFormAssigned/findFormListByProfile",
  async (profile: string | undefined, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const response = await fetch(`${api.baseURL}profileform/form-list`, {
        method: "POST",
        body: JSON.stringify({ profile: profile }),
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
